/**
 * Ein kurzer Klartext-Auszug aus Markdown — für Vorschauen, in denen kein
 * Renderer laufen soll (Karten, Zeitstrahl-Einträge).
 *
 * Kein Parser, keine Bibliothek: Nur die Zeichen weg, die in Fließtext stören
 * würden (Überschriften-Rauten, Betonungssterne, Linksyntax, Codezäune,
 * Aufzählungszeichen, Zitatpfeile), danach Weißraum glätten und kürzen.
 * Ein echter Renderer wäre hier zu viel — die Ausgabe ist reiner Text, nie
 * HTML, und geht deshalb sicher in jede Karte.
 */
export function markdownAuszug(inhalt: string, maxLaenge = 140): string {
  const klartext = inhalt
    .replace(/```[\s\S]*?```/g, " ")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^>\s?/gm, "")
    .replace(/^[-*+]\s+/gm, "")
    .replace(/^\d+\.\s+/gm, "")
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/[*_`~]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (klartext.length <= maxLaenge) return klartext;
  // An der letzten Wortgrenze vor der Grenze abschneiden — kein Wort in der
  // Mitte kappen.
  const abschnitt = klartext.slice(0, maxLaenge);
  const letzteGrenze = abschnitt.lastIndexOf(" ");
  return `${(letzteGrenze > 0 ? abschnitt.slice(0, letzteGrenze) : abschnitt).trimEnd()}…`;
}
